import BaseTableController from './base_table_controller';

// dp_id 2297 — data_grid: { rows: [{ id, name, registered_address }] }
export default class extends BaseTableController {
  connect() {
    const rows = this.initialDataValue?.rows;
    let nextId = 1;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => {
            const id = r.id != null ? r.id : nextId;
            if (id >= nextId) nextId = id + 1;
            return { id, name: r.name ?? '', registered_address: r.registered_address ?? '' };
          })
        : [{ id: 1, name: '', registered_address: '' }];
    this.nextId = Math.max(...this.rows.map((r) => r.id)) + 1;
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { id: this.nextId++, name: '', registered_address: '' };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    this.rows[index][el.dataset.field] = el.value;
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    const idTd = document.createElement('td');
    idTd.textContent = row.id;
    idTd.className = 'text-center';
    tr.appendChild(idTd);

    tr.appendChild(this.buildStringCell(row, index, 'name', 'Name'));
    tr.appendChild(this.buildStringCell(row, index, 'registered_address', 'Registered address'));
    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
